import {
  ChangeEventHandler,
  FocusEventHandler,
  TextareaHTMLAttributes
} from 'react'

import * as S from './styles'

type TextareaTypes = TextareaHTMLAttributes<HTMLTextAreaElement>

type TextareaProps = {
  label?: string
  labelColor?: string
  labelWeight?: 400 | 600
  name: string
  placeholder?: string
  hasTestTextarea?: boolean
  error?: string
  value?: string
  onChange?: ChangeEventHandler | undefined
  onBlur?: FocusEventHandler | undefined
} & TextareaTypes

const Textarea = ({
  label,
  labelColor,
  labelWeight = 400,
  hasTestTextarea,
  name,
  value,
  onChange,
  error,
  onBlur,
  ...props
}: TextareaProps) => (
  <S.Wrapper
    className="textarea-container"
    hasTestTextarea={hasTestTextarea}
    weight={labelWeight}
  >
    <label style={{ color: labelColor }} htmlFor={name}>
      {label}
    </label>
    <textarea
      id={name}
      name={name}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      {...props}
    />
    {error && <p className="error">{error}</p>}
  </S.Wrapper>
)

export default Textarea
